import React from 'react';
import { Toaster as T } from 'react-hot-toast';
import css from './Toaster.module.css';

export const Toaster = props => (
  <T containerClassName={css.toaster} toastOptions={{ className: css.toast }} {...props} />
);

export { default as toast } from 'react-hot-toast';
